<template>
    <div class="space-y-24">
        <table class="w-full">
            <thead>
                <tr class="border-b">
                    <th></th>
                    <th v-for="type in types" class="text-center font-semibold p-8 border-r last:border-r-0">
                        {{ type.name }}
                    </th>
                </tr>
            </thead>
            <tbody>
            <tr v-for="interim in interims" class="odd:bg-primary-5">
                <td class="p-8 leading-tight">
                    <span class="font-semibold">{{ interim.name }}</span><br>
                </td>
                <td v-for="type in types" class="text-center p-8 text-body-sm border-r last:border-r-0">
                    {{ getValueForType(interim, type) }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import InterimMatrixType from "../models/InterimMatrixType";
import {useRepo} from 'pinia-orm';

export default {
    props: {
        interims: Array
    },
    computed: {
        types() {
            //Get Id's from the interims that are passed
            let currentIds = this.interims.map(interim => interim.id);

            //Only return types with a value and matching interim_id
            return useRepo(InterimMatrixType)
                .whereHas('values', (value) =>  {
                    value.whereHas('interim', (interim) => {
                        interim.whereIn('id', currentIds);
                    });
                })
                .orderBy('order').all();
        }
    },
    methods: {
        getValueForType(interim, type) {
            const value = interim.matrixValues.find(i => i.type.id === type.id);

            if (!value)
                return "-";

            return value.value || "-";
        }
    }
}
</script>
